import React, { useEffect, useState } from "react";
import { Container, Dropdown, Form, Row, Col, Button } from "react-bootstrap";


import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";
import { companyGet, employeeGet, projectGet, attendancePost } from "../../../Api/Admin/AdminApi";
import { parse, format } from "date-fns";
import { formatAttendanceTime } from "../../../Utils/DateUtlis";
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";

const Attendance = () => {
  const [organizations, setOrganizations] = useState([]);
  const [project, setProject] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingCompany, setLoadingComapany] = useState(false);
  const initialData = {
    emp_id: '',
    emp_attendance_date: '',
    emp_login_time: format(new Date(), "HH:mm:ss"),
    emp_logout_time: format(new Date(), "HH:mm:ss"),
    emp_over_time: '',
    working_meter: null,
    remarks: '',
    project_id: '',
    team_id: '',
    location: '',
  }
  const [formData, setFormData] = useState(initialData);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setOrganizations(companies);
          setLoadingComapany(true)
          console.log(`API Data ${JSON.stringify(organizations)}`);  // Under Production         
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }


    const fetchProject = async () => {
      try {
        const data = await projectGet();
        if (data) {
          const employeeProject = data.results.map(i => ({
            id: i.project_id,
            name: i.project_name,
            project_location: i.project_location,
            description: i.description,
            team: i.team,
            team_id: i.team_id
          }));
          setProject(employeeProject);

        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Project: ', errorMessage || err);
        alert(errorMessage);
      }
    }

    fetchCompany();
    fetchProject();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'emp_id') {
      const selectedEmployee = employeeData.find(emp => emp.emp_id === value);
      console.log('====================================');
      console.log(selectedEmployee.team_id);
      console.log('====================================');
      if (selectedEmployee) {
        setFormData(prev => ({
          ...prev,
          [name]: value,
          team_id: selectedEmployee.team_id // Auto-set the team_id
        }));
        return;
      }
    }
    if (name === 'emp_login_time' || 'emp_logout_time') {
      const date = formatAttendanceTime(value);
      setFormData(prev => ({
        ...prev,
        [name]: date
      }))
    }
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    const currentDate = format(new Date(), "yyyy-MM-dd");

    const fullDateTime = `${formData.emp_attendance_date} ${value}:00`;
    setFormData(prev => ({
      ...prev,
      [name]: fullDateTime,

    }));

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log('FormData:', formData);

      const response = await attendancePost(formData);
      if (response) {
        alert("Attendance Posted Successfully...")
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err);
      console.log('Error in Posting Employee Attendance: ', errorMessage || err);
      alert(errorMessage);
    }
    setFormData(initialData)
  }


  const onEmployeedetails = async (id) => {
    try {
      const employees = await employeeGet(id);
      console.log("Employee data from API", employees);

      if (employees && employees.result) {
        const emp = employees.result.map(i => ({
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          team: i.team,
          team_id: i.team_id
        }));
        setEmployeeData(emp)
        // getTeam();
        setIsLoading(false)
      } else {
        setIsLoading(true)
      }

    } catch (err) {
      setIsLoading(true)
      const errorMessage = extractErrorMessage(err);
      console.log('Error Fetching Employee data', errorMessage || err);
      alert(errorMessage);
    }
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader
          title='Employee Attendance Portal'
          showButtons={true}
        />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Daily Logins
          <Dropdown onSelect={(eventKey) => {
            console.log("Selected Event Key:", eventKey);
            const selected = organizations.find(c => c.id == String(eventKey));
            console.log("Event Key:", eventKey);
            console.log("Company List:", organizations);
            console.log("Found Company: ", selected.id);
            let callID = selected.id;
            console.log(`Call ID : ${callID}`);

            setSelectedCompany(selected);
            console.log("Dropdown Selected Company: ", selectedCompany);
            onEmployeedetails(callID);
          }}>
            <Dropdown.Toggle variant="outline-secondary" id="company-dropdown">
              {selectedCompany ? selectedCompany.name : "Select Company"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {!loadingCompany ? (
                <Dropdown.Item disabled>Loading...</Dropdown.Item>
              ) : (
                organizations.map(com => (
                  <Dropdown.Item key={com.id} eventKey={com.id} active={selectedCompany?.id === com.id}>
                    {com.name}
                  </Dropdown.Item>
                ))
              )}
              {console.log(selectedCompany)
              }
            </Dropdown.Menu>
          </Dropdown>
        </h4>
        <Form onSubmit={handleSubmit} className="mt-4">
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="emp_id">
              <Form.Label>Employee Name</Form.Label>
              <Form.Select
                name="emp_id"
                value={formData.emp_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Employee</option>
                {employeeData.map(empl => (
                  <option key={empl.emp_id} value={empl.emp_id}>{empl.emp_name}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} md="4" controlId="team_id">
              <Form.Label>Team</Form.Label>
              <Form.Select
                name="team_id"
                value={formData.team_id}
                onChange={handleChange}
                required
                disabled
              >
                {formData.emp_id ? (
                  employeeData
                    .filter(emp => emp.emp_id === formData.emp_id)
                    .map(emp => (
                      <option key={emp.team_id} value={emp.team_id}>
                        {emp.team || "No team assigned"}
                      </option>
                    ))
                ) : (
                  <option value="">Select Employee first</option>
                )}
              </Form.Select>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="emp_attendance_date">
              <Form.Label>Login Date</Form.Label>
              <Form.Control
                type="date"
                name="emp_attendance_date"
                value={formData.emp_attendance_date}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="emp_login_time">
              <Form.Label>Login Time</Form.Label>
              <Form.Control
                type="time"
                name="emp_login_time"
                value={formData.emp_login_time.slice(11, 16)}
                onChange={handleDateChange}
                required
              />
              {/* <DatePicker
                selected={formData.emp_login_time}
                name="emp_login_time"
                value={formData.emp_login_time}
                onChange={(date) => handleDateChange(date, 'emp_login_time')}
                showTimeSelect
                dateFormat="yyyy-MM-dd HH:mm:ss"
                timeFormat="HH:mm"
                timeIntervals={15}
                className="form-control"
              /> */}
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="emp_logout_time">
              <Form.Label>Logout Time</Form.Label>
              <Form.Control
                type="time"
                name="emp_logout_time"
                value={formData.emp_logout_time.slice(11, 16)}
                onChange={handleDateChange}
                required
              />
              {/* <DatePicker
                selected={formData.emp_logout_time}
                name="emp_logout_time"
                value={formData.emp_logout_time}
                onChange={(date) => handleDateChange(date, 'emp_logout_time')}
                showTimeSelect
                dateFormat="yyyy-MM-dd HH:mm:ss"
                timeFormat="HH:mm"
                timeIntervals={15}
                className="form-control"
              /> */}
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="emp_over_time">
              <Form.Label>Over Time</Form.Label>
              <Form.Control
                type="number"
                name="emp_over_time"
                value={formData.emp_over_time}
                onChange={handleChange}
                placeholder="Enter Over Time"
                required
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="working_meter">
              <Form.Label>Working Meter</Form.Label>
              <Form.Control
                type="number"
                name="working_meter"
                value={formData.working_meter}
                onChange={handleChange}
                placeholder="Enter Working Meter"
                required
              />
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="location">
              <Form.Label>Location</Form.Label>
              <Form.Control
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                placeholder="Enter Location"
                required
              />
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col} md="4" controlId="project_id">
              <Form.Label>Project Name</Form.Label>
              <Form.Select
                name="project_id"
                value={formData.project_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Project</option>
                {project.map(pro => (
                  <option key={pro.id} value={pro.id}>
                    {pro.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="remarks">
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
                placeholder="Enter any remarks"
              />
            </Form.Group>
          </Row>

          <Form.Group as={Row} className="mb-4">
            <Col className='text-center'>
              <Button variant="primary" type="submit" className="mt-5">
                Submit
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </Container>
    </div>
  )
};

export default Attendance;
